import { render } from "./TrafficStats.vue?vue&type=template&id=a9b6e2c6&scoped=true"
import script from "./TrafficStats.vue?vue&type=script&lang=js"
export * from "./TrafficStats.vue?vue&type=script&lang=js"

import "./TrafficStats.vue?vue&type=style&index=0&id=a9b6e2c6&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b6e2c6"]])

export default __exports__